


































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
const L = require("leaflet");
import "@kaxline/leaflet.offline";
import "leaflet.fullscreen-cl";

// @ts-ignore
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import * as modules from "../../../store/decorator";
import axios from "axios";
import { mapDataCache } from "../../../services/mapDataCache";

import 'mapbox-gl-leaflet';

mapboxgl.accessToken = "pk.eyJ1IjoicmV0aWNtYW5hZ2VyIiwiYSI6ImNsbmdkc2JkbzB2aGYydHBkMHlqMmIwa24ifQ.F3pi5-bc0htiSJNomTw9kQ";

@Component
export default class VLeafletMaps extends Vue {
    @Prop(Number) lat!: number;
    @Prop(Number) lng!: number;
    @Prop(Boolean) displayOnly!: boolean;
    @Prop(String) searchAsset!: any;
    @Prop(String) networkCode!: any;
    @Prop(Boolean) showWW!: boolean;
    @Prop(Boolean) showSW!: boolean;
    @Prop(Boolean) showIF!: boolean;
    @Prop() assetTabData!: any;
    @Prop(String) selectedAssetId!: string;

    mapbase: any;
    map: any;
    tileLayer: any = null;
    mapSizeInterval: any;
    currentNetwork = "";
    downloading = false;

    WWNodesData: any = null;
    WWLinesData: any = null;
    SWNodesData: any = null;
    SWLinesData: any = null;
    StreetData: any = null;
    RoadData: any = null;
    CurrentPositionData: any = null;

    progress = 0;

    locationDetected: boolean = false;

    @Watch("networkCode")
    onNetworkCodeChange(val: any, oldVal: any) {
    this.currentNetwork = JSON.parse(
        JSON.stringify(this.$route.params.network)
    ).label;
    }

    @Watch("searchAsset")
    async onSearchAssetChange(val: any, oldVal: any) {
    if (val.length > 0) {
        let sourceData: any = {};
        let resultFound: boolean = false;

        this.resetLayerCSS();

        // WASTEWATER
        let target: any;
        if (this.showWW) {
            (this.WWNodesData || []).filter((sn: any) => {
                if (sn.properties.asset_id == val) {
                    target = sn;
                    resultFound = true;
                }
                return false;
            });
            if (resultFound) {
                let nodedata: any = {
                    data: {
                        asset_id: target.properties.asset_id
                    },
                    latLng: {
                        lat: target.geometry.coordinates[0],
                        lng: target.geometry.coordinates[1]
                    },
                    type: 'Manhole'
                }
                this.map.setPaintProperty('layer-gis_node-sewer', 'circle-color',
                [
                    'match',
                    ['get', 'asset_id'],
                    [val],
                    '#FFFF00',
                    '#FF583E'
                ]);
                this.map.flyTo({
                    center: [parseFloat(target.geometry.coordinates[0] + 0.00015), target.geometry.coordinates[1]],
                    zoom: 20
                });
                this.mapbase.setView([target.geometry.coordinates[1], parseFloat(target.geometry.coordinates[0] + 0.00015)]);
                this.mapbase.setZoom(20);
                this.getAddress(target.geometry.coordinates[1], target.geometry.coordinates[0]);
                this.$emit("updateLatLng", nodedata);
                sourceData["Wastewater"] = nodedata;
            } else {
                (this.WWLinesData || []).filter((sn: any) => {
                    if (sn.properties.asset_id == val) {
                        target = sn;
                        resultFound = true;
                    }
                    return false;
                });

                if (resultFound) {
                    let nodedata: any = {
                        data: {
                            asset_id: target.properties.asset_id
                        },
                        latLng: {
                            lat: target.geometry.coordinates[0][0],
                            lng: target.geometry.coordinates[0][1]
                        },
                        type: 'Pipe'
                    }
                    this.map.setPaintProperty('layer-gis_line-sewer', 'line-color',
                    [
                        'match',
                        ['get', 'asset_id'],
                        [val],
                        '#FFFF00',
                        '#FF583E'
                    ]);
                    this.map.flyTo({
                        center: [parseFloat(target.geometry.coordinates[0][0] + 0.00015), target.geometry.coordinates[0][1]],
                        zoom: 20
                    });
                    this.mapbase.setView([target.geometry.coordinates[0][1], parseFloat(target.geometry.coordinates[0][0] + 0.00015)]);
                    this.mapbase.setZoom(20);
                    this.getAddress(target.geometry.coordinates[0][1], target.geometry.coordinates[0][0]);
                    this.$emit("updateLatLng", nodedata);
                    sourceData["Wastewater"] = nodedata;
                }
            }
        }

        // STORMWATER
        if (this.showSW) {
            // Search Manhole
            if (!resultFound) {
                (this.SWNodesData || []).filter((sn: any) => {
                    if (sn.properties.asset_id == val) {
                        target = sn;
                        resultFound = true;
                    }
                    return false;
                });

                if (resultFound) {
                    let nodedata: any = {
                        data: {
                            asset_id: target.properties.asset_id
                        },
                        latLng: {
                            lat: target.geometry.coordinates[0],
                            lng: target.geometry.coordinates[1]
                        },
                        type: 'Manhole'
                    }
                    this.map.setPaintProperty('layer-gis_node-storm', 'circle-color',
                    [
                        'match',
                        ['get', 'asset_id'],
                        [val],
                        '#FFFF00',
                        '#00FF00'
                    ]);
                    this.map.flyTo({
                        center: [parseFloat(target.geometry.coordinates[0] + 0.00015), target.geometry.coordinates[1]],
                        zoom: 20
                    });
                    this.mapbase.setView([target.geometry.coordinates[1], parseFloat(target.geometry.coordinates[0] + 0.00015)]);
                    this.mapbase.setZoom(20);
                    this.getAddress(target.geometry.coordinates[1], target.geometry.coordinates[0]);
                    this.$emit("updateLatLng", nodedata);
                    sourceData["Stormwater"] = nodedata;
                } else {
                    (this.SWLinesData || []).filter((sn: any) => {
                        if (sn.properties.asset_id == val) {
                            target = sn;
                            resultFound = true;
                        }
                        return false;
                    });

                    if (resultFound) {
                        let nodedata: any = {
                            data: {
                                asset_id: target.properties.asset_id
                            },
                            latLng: {
                                lat: target.geometry.coordinates[0][0],
                                lng: target.geometry.coordinates[0][1]
                            },
                            type: 'Pipe'
                        }
                        this.map.setPaintProperty('layer-gis_line-storm', 'line-color',
                        [
                            'match',
                            ['get', 'asset_id'],
                            [val],
                            '#FFFF00',
                            '#00FF00'
                        ]);
                        this.map.flyTo({
                            center: [parseFloat(target.geometry.coordinates[0][0] + 0.00015), target.geometry.coordinates[0][1]],
                            zoom: 20
                        });
                        this.mapbase.setView([target.geometry.coordinates[0][1], parseFloat(target.geometry.coordinates[0][0] + 0.00015)]);
                        this.mapbase.setZoom(20);
                        this.getAddress(target.geometry.coordinates[0][1], target.geometry.coordinates[0][0]);
                        this.$emit("updateLatLng", nodedata);
                        sourceData["Stormwater"] = nodedata;
                    }
                }
            }
        }

        this.$emit("receiveData", sourceData);

        if (!resultFound) {
            alert("No result");
        }
    }
    }

    @Watch("showWW")
    onShowWWChange(val: any, oldVal: any) {
    if (this.showWW) {
        // ADD WW NODE & LINE LAYER
        this.map.setLayoutProperty('layer-gis_node-sewer', 'visibility', 'visible');
        this.map.setLayoutProperty('layer-gis_node_label-sewer', 'visibility', 'visible');
        this.map.setLayoutProperty('layer-gis_line-sewer', 'visibility', 'visible');
        this.map.setLayoutProperty('layer-gis_line_label-sewer', 'visibility', 'visible');
    } else {
        // REMOVE WW NODE & LINE LAYER
        this.map.setLayoutProperty('layer-gis_node-sewer', 'visibility', 'none');
        this.map.setLayoutProperty('layer-gis_node_label-sewer', 'visibility', 'none');
        this.map.setLayoutProperty('layer-gis_line-sewer', 'visibility', 'none');
        this.map.setLayoutProperty('layer-gis_line_label-sewer', 'visibility', 'none');
    }
    }
    @Watch("showSW")
    onShowSWChange(val: any, oldVal: any) {
    if (this.showSW) {
        // REMOVE WW NODE & LINE LAYER
        this.map.setLayoutProperty('layer-gis_node-storm', 'visibility', 'visible');
        this.map.setLayoutProperty('layer-gis_node_label-storm', 'visibility', 'visible');
        this.map.setLayoutProperty('layer-gis_line-storm', 'visibility', 'visible');
        this.map.setLayoutProperty('layer-gis_line_label-storm', 'visibility', 'visible');
    } else {
        // REMOVE SW NODE & LINE LAYER
        this.map.setLayoutProperty('layer-gis_node-storm', 'visibility', 'none');
        this.map.setLayoutProperty('layer-gis_node_label-storm', 'visibility', 'none');
        this.map.setLayoutProperty('layer-gis_line-storm', 'visibility', 'none');
        this.map.setLayoutProperty('layer-gis_line_label-storm', 'visibility', 'none');
    }
    }

    @Watch("showIF")
    onShowIFChange(val: any, oldVal: any) {
    if (this.showIF) {
        this.map.setLayoutProperty('layer-inflow', 'visibility', 'visible');
        this.map.setLayoutProperty('layer-inflow_label', 'visibility', 'visible');
    } else {
        this.map.setLayoutProperty('layer-inflow', 'visibility', 'none');
        this.map.setLayoutProperty('layer-inflow_label', 'visibility', 'none');
    }
    }

    @Watch("assetTabData")
    onAssetTabDataChange(val: any, oldVal: any) {
    this.map.flyTo({
        center: [parseFloat(val.latLng.lng + 0.00015), val.latLng.lat]
    });
    this.$emit("updateLatLng", val);
    this.getAddress(val.latLng.lat, val.latLng.lng);
    }

    async mounted() {
        // var root = this;
        this.currentNetwork = JSON.parse(
            JSON.stringify(this.$route.params.network)
        ).label;

        let hideStormByDefault = false;

        this.mapbase = L.map("map", {
            fullscreenControl: true,
            fullscreenControlOptions: {
            content:
                '<i class="v-icon material-icons theme--light" aria-hidden="true" style="font-size: 16px; color: #000;">fullscreen</i>'
            },
            scrollWheelZoom: false,
            doubleClickZoom: false,
            minZoom: 3,
            maxZoom: modules.user.customerDetail.maxZoom,
            updateInterval: 16
        }).setView(
            [this.lat, this.lng],
            modules.user.customerDetail.maxNativeZoom
        );

            // Offline layer
            let baseLayer = L.tileLayer
                .offline("https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}", {
                    maxNativeZoom: modules.user.customerDetail.maxNativeZoom,
                    maxZoom: modules.user.customerDetail.maxZoom,
                    subdomains: ["mt0", "mt1", "mt2", "mt3"]
                });
            if (modules.user.customerDetail.mapLayer == "esribaseLayer") {
                baseLayer = L.tileLayer
                .offline(
                "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
                {
                    maxNativeZoom: modules.user.customerDetail.maxNativeZoom,
                    maxZoom: modules.user.customerDetail.maxZoom,
                    subdomains: ["server", "services"],
                });
            }
            baseLayer.setZIndex(-1);
            baseLayer.addTo(this.mapbase);
            const baseLayerLabel = L.tileLayer
            .offline("voyager_only_labels", {
                subdomains: "abc"
            });
            baseLayerLabel.setZIndex(-1);
            baseLayerLabel.addTo(this.mapbase);
            // add buttons to save tiles in area viewed
            const control = L.control.savetiles(baseLayer, {
            zoomlevels: [modules.user.customerDetail.maxNativeZoom], // optional zoomlevels to save, default current zoomlevel
            confirm(layer: any, succescallback: any) {
                // eslint-disable-next-line no-alert
                if (window.confirm(`Save ${layer._tilesforSave.length}`)) {
                succescallback();
                }
            },
            confirmRemoval(layer: any, successCallback: any) {
                // eslint-disable-next-line no-alert
                if (window.confirm("Remove all the tiles?")) {
                successCallback();
                }
            },
            saveText:
                '<i class="v-icon material-icons theme--light" aria-hidden="true" style="font-size: 16px; color: #000;">save_alt</i>',
            rmText:
                '<i class="v-icon material-icons theme--light" aria-hidden="true" style="font-size: 18px; color: #000;">delete_forever</i>'
            });
            control.addTo(this.mapbase);

            let progressTotal = 0,
            progressInt = 0;

            baseLayer.on("storagesize", (e: any) => {});
            baseLayer.on("savestart", (e: any) => {
                this.downloading = true;
            this.progress = 0;
            progressInt = 0;
            progressTotal = e._tilesforSave.length;
            });
            baseLayer.on("savetileend", () => {
            progressInt += 1;
            this.progress = (progressInt / progressTotal) * 100;
            if (this.progress == 100) {
                this.downloading = false;
                alert('download completed');
            }
            // document.getElementById('progress').innerHTML = progress;
            });

            var mapb = L.mapboxGL({
                accessToken: mapboxgl.accessToken,
                style: {version: 8, sources: {},layers: [], glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf"},
                interactive: true,
                doubleClickZoom: false,
                scrollZoom: false,
                updateInterval: 16
            }).addTo(this.mapbase);

            var map = mapb.getMapboxMap();

        //   var map = new mapboxgl.Map({
        //       container: 'map',
        //       // style: "mapbox://styles/mapbox/satellite-v9", // Replace with your preferred map style
        //       style: {version: 8, sources: {},layers: [], glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf"},
        //       center: [this.lng, this.lat],
        //       zoom: 18,
        //       attributionControl: false
        //   });
        // this.mapbase.addControl(new mapboxgl.NavigationControl());
        // this.mapbase.addControl(new mapboxgl.FullscreenControl());

        //   map.scrollZoom.disable();
        //   map.doubleClickZoom.disable();
        map.on('moveend', () => {
            mapb._update();
        });
        map.on('dblclick', (e: any) => {
            if (!this.markerLocked) {
                this.positionHolder = {
                    lat: e.lngLat.lat, 
                    lng: e.lngLat.lng
                }
                this.markerAdded = true;

                map.getSource('source-selected_position').setData({
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [e.lngLat.lng, e.lngLat.lat]
                    }
                });
                map.setLayoutProperty('layer-selected_position', 'visibility', 'visible');
                if (map.getLayer('layer-gis_node-sewer')) {
                    map.setPaintProperty('layer-gis_node-sewer', 'circle-color', '#FF583E');
                }
                if (map.getLayer('layer-gis_node-storm')) {
                    map.setPaintProperty('layer-gis_node-storm', 'circle-color', '#00FF00');
                }

                if (this.currentNetwork == 'CCTV') {
                    let sourceData: any = {};
                    let nodedata: any = {
                        data: {
                            asset_id: ''
                        },
                        latLng: {
                            lat: e.lngLat.lat,
                            lng: e.lngLat.lng
                        },
                        type: ''
                    }
                    this.getAddress(e.lngLat.lat, e.lngLat.lng);
                    sourceData["Wastewater"] = nodedata;
                    this.$emit("updateLatLng", nodedata);
                    this.$emit("receiveData", sourceData);
                }
            }
        });

        let timeout:any;
        var touchtime = 0;
        map.on('click', (e:any) => {
            e.preventDefault();

            //DoubleCLick function
            if (touchtime == 0) {
                touchtime = new Date().getTime();
            } else {
                if (((new Date().getTime()) - touchtime) < 800) {
                    if (!this.markerLocked) {
                        this.positionHolder = {
                            lat: e.lngLat.lat, 
                            lng: e.lngLat.lng
                        }
                        this.markerAdded = true;

                        map.getSource('source-selected_position').setData({
                            type: 'Feature',
                            geometry: {
                                type: 'Point',
                                coordinates: [e.lngLat.lng, e.lngLat.lat]
                            }
                        });
                        map.setLayoutProperty('layer-selected_position', 'visibility', 'visible');
                        if (map.getLayer('layer-gis_node-sewer')) {
                            map.setPaintProperty('layer-gis_node-sewer', 'circle-color', '#FF583E');
                        }
                        if (map.getLayer('layer-gis_node-storm')) {
                            map.setPaintProperty('layer-gis_node-storm', 'circle-color', '#00FF00');
                        }

                        if (this.currentNetwork == 'CCTV') {
                            let sourceData: any = {};
                            let nodedata: any = {
                                data: {
                                    asset_id: ''
                                },
                                latLng: {
                                    lat: e.lngLat.lat,
                                    lng: e.lngLat.lng
                                },
                                type: ''
                            }
                            this.getAddress(e.lngLat.lat, e.lngLat.lng);
                            sourceData["Wastewater"] = nodedata;
                            this.$emit("updateLatLng", nodedata);
                            this.$emit("receiveData", sourceData);
                        }
                    }
                    touchtime = 0;
                } else {
                    touchtime = new Date().getTime();
                }
            }
        });
        map.on('style.load', async () => {
            if (modules.user.customerDetail.mapLayer == "esribaseLayer") {
                // esribaseLayer
                map.addSource('source-raster-esri_base', {
                    type: 'raster',
                    tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'],
                    tileSize: 256
                });
                map.addLayer({
                    id: 'layer-raster-esri_base',
                    source: 'source-raster-esri_base',
                    type: 'raster',
                    layout: {visibility: 'visible'}
                });
                window.addEventListener('online', () => {
                    map.setLayoutProperty('layer-raster-esri_base', 'visibility', 'visible');
                });
                window.addEventListener('offline', () => {
                    map.setLayoutProperty('layer-raster-esri_base', 'visibility', 'none');
                });
            }

            // SELECTED POSITION
            map.addSource('source-selected_position', {
                type: 'geojson',
                data: {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [0, 0]
                    }
                }
            });
            map.addLayer({
                id: 'layer-selected_position',
                source: 'source-selected_position',
                type: 'circle',
                minzoom: 13,
                layout: {
                    'visibility': 'none'
                },
                paint: {
                    'circle-color': '#EF6C00',
                    'circle-radius': 8,
                    'circle-stroke-color': '#B15000',
                    'circle-stroke-width': 2
                },
            });

            // CURRENT POISITON
            // Only show current position layer when creating new surveys (not editing)
            const edittarget = this.$route.query.uuid;
            if (!edittarget && !this.selectedAssetId) {
                map.addSource('source-current_position', {
                    type: 'geojson',
                    data: {
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: [this.lng, this.lat]
                        }
                    }
                });
                map.addLayer({
                    id: 'layer-current_position',
                    source: 'source-current_position',
                    type: 'circle',
                    paint: {
                        'circle-color': '#0D89FF',
                        'circle-radius': 8,
                        'circle-stroke-color': '#D5D5D5',
                        'circle-stroke-width': 2
                    },
                });
            }
            if (!edittarget) {
                let geoint = setInterval(() => {
                    if (navigator.geolocation && !this.locationDetected) {
                        this.locationDetected = true;
                        let locationCentered = false;
                        clearInterval(geoint);

                        navigator.geolocation.watchPosition(
                            pos => {
                                map.getSource('source-current_position').setData({
                                    type: 'Feature',
                                    geometry: {
                                        type: 'Point',
                                        coordinates: [pos.coords.longitude, pos.coords.latitude]
                                    }
                                });
                                if (!locationCentered) {
                                    locationCentered = true;
                                    this.mapbase.setView([pos.coords.latitude, pos.coords.longitude]);
                                }
                            },
                            err => {
                                // ERROR HANDLER
                            },
                            { enableHighAccuracy: true }
                        );
                    }
                }, 2000);
            } else {
                // In edit mode, don't auto-center on current location
                // The saved coordinates will be loaded by the parent component
            }

            // Load street and road data with caching
            const { streetData, roadData } = await this.loadStreetAndRoadData();
            this.addStreetAndRoadLayers(streetData, roadData);

            if (this.currentNetwork == 'CCTV' || window.location.search.includes('inflow-inspection')) {
                hideStormByDefault = true;
            }
            if (window.location.search.includes('inflow-inspection')) {
                // Load inflow data with caching - no setTimeout needed
                const inflowData = await this.loadInflowData();
                this.addInflowLayers(inflowData);
            }
            if ((this.currentNetwork == 'Stormwater' && !window.location.search.includes('inflow-inspection')) || hideStormByDefault) {
                setTimeout(async () => {
                    // Use cached data loading
                    const { nodesData, linesData } = await this.loadStormwaterData();
                    
                    // STORMWATER LINE
                    this.SWLinesData = linesData;
                    map.addSource('source-gis_line-storm', {
                        type: 'geojson',
                        data: {
                            type: 'FeatureCollection',
                            features: linesData
                        }
                    });
                    map.addLayer({
                        id: 'layer-gis_line-storm',
                        source: 'source-gis_line-storm',
                        type: 'line',
                        layout: {
                            'line-join': 'round',
                            'line-cap': 'round',
                            'visibility': hideStormByDefault ? 'none' : 'visible'
                        },
                        paint: {
                            'line-color': this.selectedAssetId ? 
                                ['match', ['get', 'asset_id'], [this.selectedAssetId], '#FFFF00', '#00FF00'] : '#00FF00',
                            'line-width': 2,
                            'line-opacity': 0.7
                        },
                    });

                    // UPDATE THIS CONDITION
                    if (hideStormByDefault) {
                        map.addLayer({
                            id: 'layer-gis_line_label-storm',
                            type: 'symbol',
                            source: 'source-gis_line-storm',
                            minzoom: 16,
                            layout: {
                                'symbol-placement': 'line',
                                'symbol-sort-key': 1,
                                'text-font': ['Open Sans Bold', 'Arial Unicode MS Regular'],
                                'text-field': '{asset_id}',
                                'text-size': 14,
                                'text-anchor': 'bottom',
                                'text-allow-overlap': true,
                                'text-ignore-placement': true,
                                'visibility': hideStormByDefault ? 'none' : 'visible'
                            },
                            paint: {
                                'text-color': '#efdfbb',
                                'text-halo-color': '#000',
                                'text-halo-width': 0.8
                            }
                        });
                        map.on('click', 'layer-gis_line-storm', (e: any) => {
                            this.resetLayerCSS();
                            this.positionHolder = {};
                            map.setLayoutProperty('layer-selected_position', 'visibility', 'none');
                            this.markerAdded = false;
                            this.markerLocked = false;

                            map.setPaintProperty('layer-gis_line-storm', 'line-color',
                            [
                                'match',
                                ['get', 'asset_id'],
                                [e.features[0].properties.asset_id],
                                '#FFFF00',
                                '#00FF00'
                            ]);
                            let dataToSend = {
                                data: {
                                    asset_id: e.features[0].properties.asset_id
                                },
                                type: 'Pipe',
                                latLng: {
                                    lat: e.features[0].geometry.coordinates[0][1],
                                    lng: e.features[0].geometry.coordinates[0][0]
                                }
                            };

                            this.$emit("updateLatLng", dataToSend);
                            this.getAddress(e.features[0].geometry.coordinates[0][1], e.features[0].geometry.coordinates[0][0]);

                            let sourceData = {
                                Stormwater: dataToSend
                            };
                            this.$emit("receiveData", sourceData);
                        });
                        map.on('click', 'layer-gis_line_label-storm', (e: any) => {
                            this.resetLayerCSS();
                            this.positionHolder = {};
                            map.setLayoutProperty('layer-selected_position', 'visibility', 'none');
                            this.markerAdded = false;
                            this.markerLocked = false;

                            map.setPaintProperty('layer-gis_line-storm', 'line-color',
                            [
                                'match',
                                ['get', 'asset_id'],
                                [e.features[0].properties.asset_id],
                                '#FFFF00',
                                '#00FF00'
                            ]);
                            let dataToSend = {
                                data: {
                                    asset_id: e.features[0].properties.asset_id
                                },
                                type: 'Pipe',
                                latLng: {
                                    lat: e.features[0].geometry.coordinates[0][1],
                                    lng: e.features[0].geometry.coordinates[0][0]
                                }
                            };

                            this.$emit("updateLatLng", dataToSend);
                            this.getAddress(e.features[0].geometry.coordinates[0][1], e.features[0].geometry.coordinates[0][0]);

                            let sourceData = {
                                Stormwater: dataToSend
                            };
                            this.$emit("receiveData", sourceData);
                        });
                    }

                    // STORMWATER NODE
                    this.SWNodesData = nodesData;
                    map.addSource('source-gis_node-storm', {
                        type: 'geojson',
                        data: {
                            type: 'FeatureCollection',
                            features: nodesData
                        }
                    });
                    map.addLayer({
                        id: 'layer-gis_node-storm',
                        source: 'source-gis_node-storm',
                        type: 'circle',
                        minzoom: 13,
                        layout: {
                            'visibility': hideStormByDefault ? 'none' : 'visible'
                        },
                        paint: {
                            'circle-color': this.selectedAssetId ? 
                                ['match', ['get', 'asset_id'], [this.selectedAssetId], '#FFFF00', '#00FF00'] : '#00FF00',
                            'circle-radius': 5,
                            'circle-stroke-color': '#fff',
                            'circle-stroke-width': 2
                        },
                    });
                    map.addLayer({
                        id: 'layer-gis_node_label-storm',
                        type: 'symbol',
                        source: 'source-gis_node-storm',
                        minzoom: 16,
                        layout: {
                            'symbol-placement': 'point',
                            'symbol-sort-key': 1,
                            'text-font': ['Open Sans Bold', 'Arial Unicode MS Regular'],
                            'text-field': '{asset_id}',
                            'text-size': 14,
                            'text-anchor': 'bottom',
                            'text-offset': [0, -0.5],
                            'text-allow-overlap': true,
                            'text-ignore-placement': true,
                            'visibility': hideStormByDefault ? 'none' : 'visible'
                        },
                        paint: {
                            'text-color': '#efdfbb',
                            'text-halo-color': '#000',
                            'text-halo-width': 0.8
                        }
                    });

                    map.on('click', 'layer-gis_node-storm', (e: any) => {
                        this.positionHolder = {};
                        map.setLayoutProperty('layer-selected_position', 'visibility', 'none');
                        this.markerAdded = false;
                        this.markerLocked = false;

                        map.setPaintProperty('layer-gis_node-storm', 'circle-color',
                        [
                            'match',
                            ['get', 'asset_id'],
                            [e.features[0].properties.asset_id],
                            '#FFFF00',
                            '#00FF00'
                        ]);
                        let dataToSend = {
                            data: {
                                asset_id: e.features[0].properties.asset_id
                            },
                            type: 'Manhole',
                            latLng: {
                                lat: e.features[0].geometry.coordinates[1],
                                lng: e.features[0].geometry.coordinates[0]
                            }
                        };

                        this.$emit("updateLatLng", dataToSend);
                        this.getAddress(e.features[0].geometry.coordinates[1], e.features[0].geometry.coordinates[0]);

                        let sourceData = {
                            Stormwater: dataToSend
                        };
                        this.$emit("receiveData", sourceData);
                    });
                    map.on('click', 'layer-gis_node_label-storm', (e: any) => {
                        this.positionHolder = {};
                        map.setLayoutProperty('layer-selected_position', 'visibility', 'none');
                        this.markerAdded = false;
                        this.markerLocked = false;

                        map.setPaintProperty('layer-gis_node-storm', 'circle-color',
                        [
                            'match',
                            ['get', 'asset_id'],
                            [e.features[0].properties.asset_id],
                            '#FFFF00',
                            '#00FF00'
                        ]);
                        let dataToSend = {
                            data: {
                                asset_id: e.features[0].properties.asset_id
                            },
                            type: 'Manhole',
                            latLng: {
                                lat: e.features[0].geometry.coordinates[1],
                                lng: e.features[0].geometry.coordinates[0]
                            }
                        };

                        this.$emit("updateLatLng", dataToSend);
                        this.getAddress(e.features[0].geometry.coordinates[1], e.features[0].geometry.coordinates[0]);

                        let sourceData = {
                            Stormwater: dataToSend
                        };
                        this.$emit("receiveData", sourceData);
                    });
                    map.on('mouseenter', 'layer-gis_node-storm', () => {
                        map.getCanvas().style.cursor = 'pointer';
                    });
                    map.on('mouseleave', 'layer-gis_node-storm', () => {
                        map.getCanvas().style.cursor = '';
                    });
                }, 2000);
            }

            if ((this.currentNetwork == 'Wastewater' && !window.location.search.includes('inflow-inspection')) || hideStormByDefault) {
                setTimeout(async () => {
                    // Use cached data loading
                    const { nodesData, linesData } = await this.loadWastewaterData();
                    
                    // WASTEWATER LINE
                    this.WWLinesData = linesData;
                    map.addSource('source-gis_line-sewer', {
                        type: 'geojson',
                        data: {
                            type: 'FeatureCollection',
                            features: linesData
                        }
                    });
                    map.addLayer({
                        id: 'layer-gis_line-sewer',
                        source: 'source-gis_line-sewer',
                        type: 'line',
                        layout: {
                            'line-join': 'round',
                            'line-cap': 'round'
                        },
                        paint: {
                            'line-color': this.selectedAssetId ? 
                                ['match', ['get', 'asset_id'], [this.selectedAssetId], '#FFFF00', '#FF583E'] : '#FF583E',
                            'line-width': 2,
                            'line-opacity': 0.7
                        },
                    });

                    if (hideStormByDefault) {
                        map.addLayer({
                            id: 'layer-gis_line_label-sewer',
                            type: 'symbol',
                            source: 'source-gis_line-sewer',
                            minzoom: 16,
                            layout: {
                                'symbol-placement': 'line',
                                'symbol-sort-key': 1,
                                'text-font': ['Open Sans Bold', 'Arial Unicode MS Regular'],
                                'text-field': '{asset_id}',
                                'text-size': 14,
                                'text-anchor': 'bottom',
                                'text-allow-overlap': true,
                                'text-ignore-placement': true
                            },
                            paint: {
                                'text-color': '#efdfbb',
                                'text-halo-color': '#000',
                                'text-halo-width': 0.8
                            }
                        });
                        map.on('click', 'layer-gis_line-sewer', (e: any) => {
                            this.resetLayerCSS();
                            this.positionHolder = {};
                            map.setLayoutProperty('layer-selected_position', 'visibility', 'none');
                            this.markerAdded = false;
                            this.markerLocked = false;

                            map.setPaintProperty('layer-gis_line-sewer', 'line-color',
                            [
                                'match',
                                ['get', 'asset_id'],
                                [e.features[0].properties.asset_id],
                                '#FFFF00',
                                '#FF583E'
                            ]);
                            let dataToSend = {
                                data: {
                                    asset_id: e.features[0].properties.asset_id
                                },
                                type: 'Pipe',
                                latLng: {
                                    lat: e.features[0].geometry.coordinates[0][1],
                                    lng: e.features[0].geometry.coordinates[0][0]
                                }
                            };

                            this.$emit("updateLatLng", dataToSend);
                            this.getAddress(e.features[0].geometry.coordinates[0][1], e.features[0].geometry.coordinates[0][0]);

                            let sourceData = {
                                Wastewater: dataToSend
                            };
                            this.$emit("receiveData", sourceData);
                        });
                        map.on('click', 'layer-gis_line_label-sewer', (e: any) => {
                            this.resetLayerCSS();
                            this.positionHolder = {};
                            map.setLayoutProperty('layer-selected_position', 'visibility', 'none');
                            this.markerAdded = false;
                            this.markerLocked = false;

                            map.setPaintProperty('layer-gis_line-sewer', 'line-color',
                            [
                                'match',
                                ['get', 'asset_id'],
                                [e.features[0].properties.asset_id],
                                '#FFFF00',
                                '#FF583E'
                            ]);
                            let dataToSend = {
                                data: {
                                    asset_id: e.features[0].properties.asset_id
                                },
                                type: 'Pipe',
                                latLng: {
                                    lat: e.features[0].geometry.coordinates[0][1],
                                    lng: e.features[0].geometry.coordinates[0][0]
                                }
                            };

                            this.$emit("updateLatLng", dataToSend);
                            this.getAddress(e.features[0].geometry.coordinates[0][1], e.features[0].geometry.coordinates[0][0]);

                            let sourceData = {
                                Wastewater: dataToSend
                            };
                            this.$emit("receiveData", sourceData);
                        });
                    }

                    // WASTEWATER NODE
                    this.WWNodesData = nodesData;
                    map.addSource('source-gis_node-sewer', {
                        type: 'geojson',
                        data: {
                            type: 'FeatureCollection',
                            features: nodesData
                        }
                    });
                    map.addLayer({
                        id: 'layer-gis_node-sewer',
                        source: 'source-gis_node-sewer',
                        type: 'circle',
                        minzoom: 13,
                        paint: {
                            'circle-color': this.selectedAssetId ? 
                                ['match', ['get', 'asset_id'], [this.selectedAssetId], '#FFFF00', '#FF583E'] : '#FF583E',
                            'circle-radius': 5,
                            'circle-stroke-color': '#fff',
                            'circle-stroke-width': 2
                        },
                    });
                    map.addLayer({
                        id: 'layer-gis_node_label-sewer',
                        type: 'symbol',
                        source: 'source-gis_node-sewer',
                        minzoom: 16,
                        layout: {
                            'symbol-placement': 'point',
                            'symbol-sort-key': 1,
                            'text-font': ['Open Sans Bold', 'Arial Unicode MS Regular'],
                            'text-field': '{asset_id}',
                            'text-size': 14,
                            'text-anchor': 'bottom',
                            'text-offset': [0, -0.5],
                            'text-allow-overlap': true,
                            'text-ignore-placement': true
                        },
                        paint: {
                            'text-color': '#efdfbb',
                            'text-halo-color': '#000',
                            'text-halo-width': 0.8
                        }
                    });

                    map.on('click', 'layer-gis_node-sewer', (e: any) => {
                        this.resetLayerCSS();
                        this.positionHolder = {};
                        map.setLayoutProperty('layer-selected_position', 'visibility', 'none');
                        this.markerAdded = false;
                        this.markerLocked = false;

                        map.setPaintProperty('layer-gis_node-sewer', 'circle-color',
                        [
                            'match',
                            ['get', 'asset_id'],
                            [e.features[0].properties.asset_id],
                            '#FFFF00',
                            '#FF583E'
                        ]);
                        let dataToSend = {
                            data: {
                                asset_id: e.features[0].properties.asset_id
                            },
                            type: 'Manhole',
                            latLng: {
                                lat: e.features[0].geometry.coordinates[1],
                                lng: e.features[0].geometry.coordinates[0]
                            }
                        };

                        this.$emit("updateLatLng", dataToSend);
                        this.getAddress(e.features[0].geometry.coordinates[1], e.features[0].geometry.coordinates[0]);

                        let sourceData = {
                            Wastewater: dataToSend
                        };
                        this.$emit("receiveData", sourceData);
                    });
                    map.on('click', 'layer-gis_node_label-sewer', (e: any) => {
                        this.resetLayerCSS();
                        this.positionHolder = {};
                        map.setLayoutProperty('layer-selected_position', 'visibility', 'none');
                        this.markerAdded = false;
                        this.markerLocked = false;

                        map.setPaintProperty('layer-gis_node-sewer', 'circle-color',
                        [
                            'match',
                            ['get', 'asset_id'],
                            [e.features[0].properties.asset_id],
                            '#FFFF00',
                            '#FF583E'
                        ]);
                        let dataToSend = {
                            data: {
                                asset_id: e.features[0].properties.asset_id
                            },
                            type: 'Manhole',
                            latLng: {
                                lat: e.features[0].geometry.coordinates[1],
                                lng: e.features[0].geometry.coordinates[0]
                            }
                        };

                        this.$emit("updateLatLng", dataToSend);
                        this.getAddress(e.features[0].geometry.coordinates[1], e.features[0].geometry.coordinates[0]);

                        let sourceData = {
                            Wastewater: dataToSend
                        };
                        this.$emit("receiveData", sourceData);
                    });
                    map.on('mouseenter', 'layer-gis_node-sewer', () => {
                        map.getCanvas().style.cursor = 'pointer';
                    });
                    map.on('mouseleave', 'layer-gis_node-sewer', () => {
                        map.getCanvas().style.cursor = '';
                    });
                }, 5000);
            }

            setInterval(() => {
                this.mapbase.invalidateSize();
                map.resize();
            }, 5000);

            this.map = map;
            
            // Now that map is ready, load cached data
            this.loadAndAddCachedLayers(hideStormByDefault);
        });
    }

    beforeUnmount() {
    this.map.remove();
    }

    centerMap() {
    this.map.flyTo({
        center: [this.lng, this.lat]
    });
    }

    mapPressTimeout: any;
    addedMarker: any;
    markerAdded: Boolean = false;
    markerLocked: Boolean = false;

    positionHolder: any;

    mapIsReady() {
    clearInterval(this.mapSizeInterval);
    }

    mapClickReset() {
    clearTimeout(this.mapPressTimeout);
    }

    pinPosition() {
    if (!this.markerLocked) {
        let dataToSend = {
        data: {
            asset_id: ""
        },
        latLng: this.positionHolder
        };
        this.markerLocked = true;
        this.$emit("updateLatLng", dataToSend);
        this.getAddress(this.positionHolder.lat, this.positionHolder.lng);
    }
    }

    unpinPosition() {
    this.positionHolder = {};
    this.markerAdded = false;
    this.markerLocked = false;
    this.map.setLayoutProperty('layer-selected_position', 'visibility', 'none');
    }

    async getAddress(lat: any, lng: any) {
    const instance = axios.create();
    instance
        .get("https://maps.googleapis.com/maps/api/geocode/json", {
        params: {
            key: "AIzaSyDOChq759QABLcNroIYv9jp6Ys3aMgwCig",
            latlng: lat + "," + lng,
            sensor: true,
            type: "address"
        }
        })
        .then(response => {
        this.$emit("updateAddress", response);
        });
    }

    resetLayerCSS() {
        if (this.map.getLayer('layer-gis_node-sewer')) {
            this.map.setPaintProperty('layer-gis_node-sewer', 'circle-color', '#FF583E');
            this.map.setPaintProperty('layer-gis_line-sewer', 'line-color', '#FF583E');
        }
        if (this.map.getLayer('layer-gis_node-storm')) {
            this.map.setPaintProperty('layer-gis_node-storm', 'circle-color', '#00FF00');
            this.map.setPaintProperty('layer-gis_line-storm', 'line-color', '#00FF00');
        }
        if (this.map.getLayer('layer-inflow')) {
            this.map.setPaintProperty('layer-inflow', 'circle-color', '#FF583E');
        }
    }

    // Helper methods for consistent data loading and layer management
    async loadStreetAndRoadData() {
        const customerId = modules.user.customerDetail.customerId;
        
        // Try to get cached data first
        let streetData = mapDataCache.getStreetData(customerId);
        let roadData = mapDataCache.getRoadData(customerId);
        
        // If no cached data, fetch from API
        if (!streetData || !roadData) {
            const responses = await Promise.all([
                axios.post('https://api.reticmanager.com/vpc-data/street_no', {
                    customer_id: customerId
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'GpPOxVP1zuZm5iGjAp1r'
                    }
                }),
                axios.post('https://api.reticmanager.com/vpc-data/road_name', {
                    customer_id: customerId
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'GpPOxVP1zuZm5iGjAp1r'
                    }
                })
            ]);
            
            streetData = responses[0].data;
            roadData = responses[1].data;
            
            // Cache the data
            mapDataCache.setStreetData(streetData, customerId);
            mapDataCache.setRoadData(roadData, customerId);
        }
        
        return { streetData, roadData };
    }

    async loadInflowData() {
        const customerId = modules.user.customerDetail.customerId;
        
        // Try to get cached data first
        let inflowData = mapDataCache.getInflowData(customerId);
        
        // If no cached data, fetch from API
        if (!inflowData) {
            const response = await axios.post('https://api.reticmanager.com/vpc-data/inflow', {
                customer_id: customerId
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'GpPOxVP1zuZm5iGjAp1r'
                }
            });
            
            inflowData = response.data;
            
            // Cache the data
            mapDataCache.setInflowData(inflowData, customerId);
        }
        
        return inflowData;
    }

    async loadStormwaterData() {
        const customerId = modules.user.customerDetail.customerId;
        
        // Try to get cached data first
        let nodesData = mapDataCache.getStormNodesData(customerId);
        let linesData = mapDataCache.getStormLinesData(customerId);
        
        // If no cached data, fetch from API
        if (!nodesData || !linesData) {
            const responses = await Promise.all([
                axios.post('https://api.reticmanager.com/vpc-data/gis/node', {
                    customer_id: customerId,
                    network: 'storm'
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'GpPOxVP1zuZm5iGjAp1r'
                    }
                }),
                axios.post('https://api.reticmanager.com/vpc-data/gis/line', {
                    customer_id: customerId,
                    network: 'storm'
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'GpPOxVP1zuZm5iGjAp1r'
                    }
                })
            ]);
            
            nodesData = responses[0].data;
            linesData = responses[1].data;
            
            // Cache the data
            mapDataCache.setStormNodesData(nodesData, customerId);
            mapDataCache.setStormLinesData(linesData, customerId);
        }
        
        return { nodesData, linesData };
    }

    async loadWastewaterData() {
        const customerId = modules.user.customerDetail.customerId;
        
        // Try to get cached data first
        let nodesData = mapDataCache.getSewerNodesData(customerId);
        let linesData = mapDataCache.getSewerLinesData(customerId);
        
        // If no cached data, fetch from API
        if (!nodesData || !linesData) {
            const responses = await Promise.all([
                axios.post('https://api.reticmanager.com/vpc-data/gis/node', {
                    customer_id: customerId,
                    network: 'sewer'
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'GpPOxVP1zuZm5iGjAp1r'
                    }
                }),
                axios.post('https://api.reticmanager.com/vpc-data/gis/line', {
                    customer_id: customerId,
                    network: 'sewer'
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'GpPOxVP1zuZm5iGjAp1r'
                    }
                })
            ]);
            
            nodesData = responses[0].data;
            linesData = responses[1].data;
            
            // Cache the data
            mapDataCache.setSewerNodesData(nodesData, customerId);
            mapDataCache.setSewerLinesData(linesData, customerId);
        }
        
        return { nodesData, linesData };
    }

    addStreetAndRoadLayers(streetData, roadData) {
        if (!this.map) return; // Safety check
        // STREET
        this.map.addSource('source-street', {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: streetData
            }
        });
        this.map.addLayer({
            'id': 'layer-street_symbol',
            'type': 'symbol',
            'source': 'source-street',
            minzoom: 15,
            'layout': {
                'symbol-placement': 'point',
                'text-font': ['Open Sans Bold', 'Arial Unicode MS Regular'],
                'text-field': '{full_address_number}',
                'text-size': 14
            },
            'paint': {
                'text-color': '#000',
                'text-halo-color': '#fff',
                'text-halo-width': 0.8
            }
        });

        // ROAD
        this.map.addSource('source-road', {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: roadData
            }
        });
        this.map.addLayer({
            id: 'layer-road_symbol',
            type: 'symbol',
            source: 'source-road',
            minzoom: 15,
            layout: {
                'symbol-placement': 'line',
                'symbol-sort-key': 3,
                'text-font': ['Open Sans Bold', 'Arial Unicode MS Regular'],
                'text-field': '{road_name_label}',
                'text-size': 14,
                'text-allow-overlap': true,
                'text-ignore-placement': true
            },
            paint: {
                'text-color': '#000',
                'text-halo-color': '#fff',
                'text-halo-width': 0.8
            }
        });
    }

    addInflowLayers(inflowData) {
        if (!this.map) return; // Safety check
        this.map.addSource('source-inflow', {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: inflowData
            }
        });
        this.map.addLayer({
            id: 'layer-inflow',
            source: 'source-inflow',
            type: 'circle',
            minzoom: 13,
            layout: {
                'visibility': 'visible'
            },
            paint: {
                'circle-color': '#FF583E',
                'circle-radius': 5,
                'circle-stroke-color': '#fff',
                'circle-stroke-width': 2
            },
        });

        this.map.addLayer({
            id: 'layer-inflow_label',
            type: 'symbol',
            source: 'source-inflow',
            minzoom: 16,
            layout: {
                'symbol-placement': 'point',
                'symbol-sort-key': 1,
                'text-font': ['Open Sans Bold', 'Arial Unicode MS Regular'],
                'text-field': '{asset_id}',
                'text-size': 14,
                'text-anchor': 'bottom',
                'text-offset': [0, -0.5],
                'text-allow-overlap': true,
                'text-ignore-placement': true,
                'visibility': 'visible'
            },
            paint: {
                'text-color': '#efdfbb',
                'text-halo-color': '#000',
                'text-halo-width': 0.8
            }
        });

        // Add event handlers
        this.map.on('click', 'layer-inflow', (e) => {
            this.resetLayerCSS();
            this.positionHolder = {};
            this.map.setLayoutProperty('layer-selected_position', 'visibility', 'none');
            this.markerAdded = false;
            this.markerLocked = false;

            this.map.setPaintProperty('layer-inflow', 'circle-color',
            [
                'match',
                ['get', 'asset_id'],
                [e.features[0].properties.asset_id],
                '#FFFF00',
                '#FF583E'
            ]);
            let dataToSend = {
                data: {
                    asset_id: e.features[0].properties.asset_id
                },
                type: 'Inflow',
                latLng: {
                    lat: e.features[0].geometry.coordinates[1],
                    lng: e.features[0].geometry.coordinates[0]
                }
            };

            this.$emit("updateLatLng", dataToSend);
            this.getAddress(e.features[0].geometry.coordinates[1], e.features[0].geometry.coordinates[0]);

            let sourceData = {
                Stormwater: dataToSend
            };
            this.$emit("receiveData", sourceData);
        });
        
        this.map.on('click', 'layer-inflow_label', (e) => {
            this.resetLayerCSS();
            this.positionHolder = {};
            this.map.setLayoutProperty('layer-selected_position', 'visibility', 'none');
            this.markerAdded = false;
            this.markerLocked = false;

            this.map.setPaintProperty('layer-inflow', 'circle-color',
            [
                'match',
                ['get', 'asset_id'],
                [e.features[0].properties.asset_id],
                '#FFFF00',
                '#FF583E'
            ]);
            let dataToSend = {
                data: {
                    asset_id: e.features[0].properties.asset_id
                },
                type: 'Inflow',
                latLng: {
                    lat: e.features[0].geometry.coordinates[1],
                    lng: e.features[0].geometry.coordinates[0]
                }
            };

            this.$emit("updateLatLng", dataToSend);
            this.getAddress(e.features[0].geometry.coordinates[1], e.features[0].geometry.coordinates[0]);

            let sourceData = {
                Stormwater: dataToSend
            };
            this.$emit("receiveData", sourceData);
        });
        
        this.map.on('mouseenter', 'layer-inflow', () => {
            this.map.getCanvas().style.cursor = 'pointer';
        });
        
        this.map.on('mouseleave', 'layer-inflow', () => {
            this.map.getCanvas().style.cursor = '';
        });
    }

    async loadAndAddCachedLayers(hideStormByDefault) {
        // Load street and road data with caching
        const { streetData, roadData } = await this.loadStreetAndRoadData();
        this.addStreetAndRoadLayers(streetData, roadData);

        // Load inflow data if needed
        if (window.location.search.includes('inflow-inspection')) {
            const inflowData = await this.loadInflowData();
            this.addInflowLayers(inflowData);
        }
        
        // Note: Storm/sewer layers are still handled by the original setTimeout logic
        // to avoid duplicate layer creation conflicts
    }
}
